
// Sources for the armpit cysts article
export const armpitCystsSources = [
  {
    text: "American Academy of Dermatology: 'Cysts'",
    link: "https://www.aad.org/public/diseases/bumps-and-growths/cysts"
  },
  {
    text: "Mayo Clinic: 'Hidradenitis suppurativa'",
    link: "https://www.mayoclinic.org/diseases-conditions/hidradenitis-suppurativa/symptoms-causes/syc-20352306"
  },
  {
    text: "Cleveland Clinic: 'Sebaceous Cysts'",
    link: "https://my.clevelandclinic.org/health/diseases/16096-sebaceous-cysts"
  },
  {
    text: "National Health Service (NHS): 'Skin cysts'",
    link: "https://www.nhs.uk/conditions/skin-cyst/"
  }
];
